export const BLOG_CONSTS = {
    SET_BLOG_PAGE: "SET_BLOG_PAGE",
    SET_BLOG_LIST: "SET_BLOG_LIST",
    GET_BLOG_BY_ID: "GET_BLOG_BY_ID",
    UPDATE_BLOG_ITEM: "UPDATE_BLOG_ITEM",
    DELETE_BLOG_ITEM: "DELETE_BLOG_ITEM",
};
